export interface ConnectionAccessVisibilityRow {
  isManagedByCurrentUser: boolean;
}

export const getManagedConnectionRows = <TRow extends ConnectionAccessVisibilityRow>(
  rows: TRow[]
): TRow[] => rows.filter((row) => row.isManagedByCurrentUser);

export const getVisibleConnectionRows = <TRow extends ConnectionAccessVisibilityRow>(
  rows: TRow[]
): TRow[] => rows;
